import { Link, useParams } from "react-router-dom";
import { Posts, illustrationSlugs } from '../Constants';
import GoToTop from '../components/GoToTop';
import '../styles/IllustrationDetails.css';

const linkStyle = {
    textDecoration: "none",
    color: 'black'
  };

function IllustrationDetail() {
    const { slug } = useParams();
    const post = Posts[slug];

    if(!post) {
        return <span>The page you've requested does not exist.</span>;
    }

    const {title, description, more_images} = post;

    let moreImagesList = null;
    if (more_images.length > 0) {
        moreImagesList = (
            more_images.map((image, index) =>
                <img key={slug+index} src={image} alt={slug+index} />
            )
        );
    }

    const index = illustrationSlugs.indexOf(slug);
    const prevSlug = index > 0 ? illustrationSlugs[index - 1] : '';
    const nextSlug =
        index >= 0 && index < illustrationSlugs.length - 1
            ? illustrationSlugs[index + 1]
            : '';

    const newDesc = description.split('{\n}').map(str => <p>{str}</p>);

    return (
        <div className="postContainer">
            <div className="linkContainer">
                <div className="left">
                    <Link to={`/`} style={linkStyle}> Back to Illustration </Link>
                </div>
                <div className="right">
                    {prevSlug !== '' && <Link to={`/illustration/${prevSlug}`}  style={linkStyle}> prev </Link>}
                    / {nextSlug !== '' && <Link to={`/illustration/${nextSlug}`}  style={linkStyle}> next </Link>}
                </div>
            </div>
            <div className="detailsContainer">
                <div className="detailImages">
                    {moreImagesList != null ? moreImagesList : null}
                </div>
                <div className="description">
                    <h1 className="title">{title}</h1>
                    <br />
                    {newDesc}
                </div>
            </div>
            <div className="linkContainer">
                <div className="left">
                    <Link to={`/`} style={linkStyle}> Back to Illustration </Link>
                </div>
                <div className="right">
                    {prevSlug !== '' && <Link to={`/illustration/${prevSlug}`}  style={linkStyle}> prev </Link>}
                    / {nextSlug !== '' && <Link to={`/illustration/${nextSlug}`}  style={linkStyle}> next </Link>}
                </div>
            </div>
            <GoToTop />
        </div>
    );
}

export default IllustrationDetail;